import React from 'react';
import UsersList from './list';
import { Route, Routes } from 'react-router-dom';
import UserDetails from './details';
import { useIsFactoryAdmin } from '../../auth';

export default function UsersView() {
    const isFactoryAdmin = useIsFactoryAdmin();
    if (!isFactoryAdmin) return null;

    return (
        <Routes>
            <Route path='/' exact element={<UsersList />} />
            <Route path='/:id' element={<UserDetails />} />
        </Routes>
    );
}
